var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.settings.isUsersOnline)?_c('nav',{staticClass:"navContainer"},[(_vm.realtimeTotal === 1)?_c('div',[_vm._v(" "+_vm._s(_vm.realtimeTotal)+" User Online ")]):_c('div',[_vm._v(" "+_vm._s(_vm.realtimeTotal)+" Users Online ")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }